import { paths } from '@/config/path'

export function getInviteUrl(code: string) {
  return `${window.location.origin}${paths.auth.register.path}?invite=${code}`
}
